<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-29 18:35:29
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchManage\components\Wifi\viewWifi.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-08-03 17:06:43
-->
<template>
  <normalDialog
    :dialog="show"
    :title="$t('label_essweb_punchManage_list_wifi_dialog_viewTitle')"
    @close="closeDialog"
    :width="680"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0 pb-0">
            <v-switch
              color="primary"
              :disabled="!iSEdited"
              v-model="Data.status"
              :label="
                Data.status
                  ? $t('label_essweb_punchManage_list_wifi_dialog_activeLabel')
                  : ''
              "
            ></v-switch>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :bindData="Data.criteria_wifi_name"
              @change="
                (valueArr) => {
                  Data.criteria_wifi_name = valueArr;
                }
              "
              :label="$t('label_essweb_punchManage_list_wifi_dialog_nameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :bindData="Data.criteria_wifi_description"
              @change="
                (valueArr) => {
                  Data.criteria_wifi_description = valueArr;
                }
              "
              :label="
                $t('label_essweb_punchManage_list_wifi_dialog_descriptionLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_punchManage_list_wifi_dialog_siteLabel")
            }}</v-sheet>
            <v-select
              :items="siteList"
              item-text="site_name"
              item-value="uuid"
              single-line
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              dense
              v-model="Data.site_uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :placeholder="
                $t('label_essweb_punchManage_list_wifi_dialog_siteLabel')
              "
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              :readonly="!iSEdited"
              :filled="iSEdited"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t('label_essweb_punchManage_list_wifi_dialog_pssIdLabel')
              "
              v-model="Data.ssid"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :defaultTime="Data.effective_utc_datetime"
              :max="Data.expired_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="
                $t(
                  'label_essweb_punchManage_list_wifi_dialog_effectiveStartDateLabel'
                )
              "
              @change="(time) => (Data.effective_utc_datetime = time)"
            />
          </v-col>
          <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
            <v-sheet class="text--secondary">Time Zone</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              single-line
              v-model="Data.effective_time_zone"
              dense
              placeholder="time zone"
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
              </v-select>
          </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :defaultTime="Data.expired_utc_datetime"
              :min="Data.effective_utc_datetime"
              :label="
                $t(
                  'label_essweb_punchManage_list_wifi_dialog_expiredEndDateLabel'
                )
              "
              @change="(time) => (Data.expired_utc_datetime = time)"
            />
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchManage_list_wifi_dialog_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              :readonly="!iSEdited"
              :filled="iSEdited"
              single-line
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              v-model="Data.expired_time_zone"
              dense
              :placeholder="
                $t('label_essweb_punchManage_list_wifi_dialog_timeZoneLabel')
              "
            >
              <template v-slot:no-data> <noContent /> </template>
              </v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchManage_list_wifi_dialog_remarkLabel")
            }}</v-sheet>
            <v-text-field
              dense
              single-line
              :readonly="!iSEdited"
              :filled="iSEdited"
              :placeholder="
                $t('label_essweb_punchManage_list_wifi_dialog_remarkLabel')
              "
              v-model="Data.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions
        saveBtn
        @save="toSave"
        @cancel="closeDialog"
        v-if="iSEdited"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editWifi",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
    siteList() {
      return this.$getSelectTrans(this.siteListData, "site_name");
    },
  },
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: "", type: String },
  },
  data() {
    return {
      siteListData: [],
      iSEdited: false,
      Data: {
        status: 0,
        criteria_wifi_name: "",
        criteria_wifi_description: "",
        ssid_encrypt: "",
        site_uuid: "",
        ssid: "",
        effective_utc_datetime: "",
        effective_time_zone: "",
        expired_utc_datetime: "",
        expired_time_zone: "",
        criteria_type_uuid: "",
        remarks: "",
      },
    };
  },
  mounted() {
    this.getSiteList();
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.Data = {
          status: 0,
          criteria_wifi_name: "",
          criteria_wifi_description: "",
          ssid_encrypt: "",
          site_uuid: "",
          ssid: "",
          effective_utc_datetime: "",
          effective_time_zone: "",
          expired_utc_datetime: "",
          expired_time_zone: "",
          criteria_type_uuid: "",
          remarks: "",
        };
      }
    },
    curUuid(val) {
      if (val) {
        this.getDetail(val);
      }
    },
    "Data.expired_time_zone": function (val) {
      this.Data.effective_time_zone = val;
    },
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getSiteList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-list/",
      }).then((res) => {
        that.siteListData = res.data;
      });
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_punch_criteria_wifi",
        url: "/wifi-criteria/get-wifi-criteria-details/",
        data: { uuid: uuid },
      }).then((res) => {
        res.data["criteria_wifi_name_save"] = res.data.criteria_wifi_name;
        res.data.criteria_wifi_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.criteria_wifi_name
        );
        res.data["criteria_wifi_description_save"] =
          res.data.criteria_wifi_description;
        res.data.criteria_wifi_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.criteria_wifi_description
        );
        res.data.effective_utc_datetime = that.$getDateTime(
          res.data.effective_utc_datetime,
          "YYYY-MM-DD"
        );
        res.data.expired_utc_datetime = that.$getDateTime(
          res.data.expired_utc_datetime,
          "YYYY-MM-DD"
        );
        that.Data = res.data;
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onEdit", "wifi", this.Data);
    },
  },
};
</script>
